import React, { Suspense } from "react";

import type { ProfileImageProps } from "./ProfileImageInner";
import { cn } from "@/lib/utils";

const LazyProfileImage = React.lazy(() =>
  import("./ProfileImageInner").then((mod) => ({
    default: mod.ProfileImage,
  })),
);

export const ProfileImage = (props: ProfileImageProps) => {
  return (
    <Suspense
      fallback={
        <div
          className={cn(
            "flex h-16 w-16 items-center justify-center rounded-full border border-dashed border-muted-foreground/40 text-xs text-muted-foreground",
            props.avatarClassName,
          )}
        >
          Loading…
        </div>
      }
    >
      <LazyProfileImage {...props} />
    </Suspense>
  );
};

export type { ProfileImageProps } from "./ProfileImageInner";
